import * as React from "react";
import {
  Text,
  View,
  Dimensions,
  StyleSheet,
  TouchableOpacity,
  Platform,
  Linking,
} from "react-native";

import GlobalStyles from "../../components/GlobalStyles";
import { Ionicons } from "@expo/vector-icons";
import Colors from "../../utilities/Color.js";
import { useNavigation } from "@react-navigation/native";
import UnderLine from "../../components/AnimatedUnderLine";

export default function WebBuyActionScreen() {
  const win = Dimensions.get("window");
  const navigation = useNavigation();
  return (
    <View style={GlobalStyles.containerMB}>
      <View
        style={
          win.width > 768
            ? GlobalStyles.adjustableBodyContainer
            : GlobalStyles.bodyContainerT
        }
      >
        <View style={styles.bodyContainer}>
          <Text
            style={[
              styles.TextStylePrompt,
              { fontSize: 22, marginBottom: 20, fontFamily: "montserrat-bold" },
            ]}
          >
            Join free to earn real cashback rewards with every purchase.
          </Text>
          <View style={styles.submitLoginButtonContainer}>
            <TouchableOpacity
              style={styles.submitRegisterButtonStyle}
              activeOpacity={0.5}
              onPress={() => {
                Platform.OS !== "web"
                  ? Linking.openURL("https://app.aura.club/signupchoice")
                  : window.open("https://app.aura.club/signupchoice", "_blank");
              }}
            ><Text style={styles.TextStyleLink}>
                <Text style={styles.TextStyleLinkSmall}>New member? </Text>
                <Text style={styles.TextStyleLink}>REGISTER NOW</Text>
              </Text>
            </TouchableOpacity>
          </View>
          <Text style={styles.TextStylePrompt}>ALREADY A MEMBER?</Text>

          <View style={styles.submitLoginButtonContainer}>
            <TouchableOpacity
              style={styles.submitLoginButtonStyle}
              activeOpacity={0.5}
              onPress={() => {
                Platform.OS !== "web"
                  ? Linking.openURL("https://app.aura.club/loginchoice")
                  : window.open("https://app.aura.club/loginchoice", "_blank");
              }}
            >
              <Text style={styles.TextStyleLink}>LOG IN</Text>
            </TouchableOpacity>
          </View>
          <View style={styles.backButtonContainer}>
          <TouchableOpacity
            style={styles.linkStyle}
            activeOpacity={0.5}
            onPress={() => navigation.goBack()}
          >
            <Text style={styles.BackTextStyleLink}>BACK</Text>
            <UnderLine />
          </TouchableOpacity></View>
          <View style={styles.emptyContainer}></View>
        </View>
      </View>
    </View>
  );
}

function OptionButton({ icon, label, onPress }) {
  return (
    <TouchableOpacity
      style={styles.containerBox}
      activeOpacity={0.7}
      onPress={onPress}
    >
      <View style={styles.SubmitButtonStyle}>
        <View style={styles.optionIconContainer}>
          <Ionicons name={icon} size={24} color="rgba(0,0,0,0.99)" />
        </View>
        <View style={styles.optionTextContainer}>
          <Text style={styles.optionText}>{label}</Text>
        </View>
        <View style={styles.optionIconContainer}></View>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  buttonStyle: {
    marginTop: 10,
    paddingTop: 15,
    paddingBottom: 15,
    backgroundColor: "#337599",
    borderRadius: 30,
  },
  container: {
    paddingTop: 20,
    marginLeft: 30,
    marginRight: 30,
  },
  containerA: {
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 20,
    paddingBottom: 50,
  },

  tinyLogo: {
    height: 70,
    width: 120,
  },

  optionIconContainer: {
    flex: 1,
    alignItems: "center",
  },

  optionTextContainer: {
    flex: 8,
    alignSelf: "center",
  },

  optionText: {
    color: "#506685",
    fontFamily: "montserrat-bold",
    fontSize: 15,
    textAlign: "center",
  },

  containerBox: {
    //flex: 1,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    paddingTop: 15,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 15,
    marginBottom: 20,
    width: 350,
    alignSelf: "center",
  },

  SubmitButtonStyle: {
    flexDirection: "row",
  },

  TextStyleLink: {
    color: "#333333",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },

  TextStyleLinkSmall: {
    color: "#333333",
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 14,
  },

  BackTextStyleLink: {
    color: "#FFFFFF",
    textAlign: "center",
    fontFamily: "montserrat-bold",
    fontSize: 14,
  },

  TextStylePrompt: {
    color: Colors.WHITE,
    textAlign: "center",
    fontFamily: "montserrat-regular",
    fontSize: 12,
    paddingTop: 50,
    paddingBottom: 10,
  },
  submitRegisterButtonStyle: {
    borderRadius: 50,
    backgroundColor: Colors.YELLOW,
    justifyContent: "center",
    height: 52,
    width: 300,
    alignSelf: "center",
  },
  submitLoginButtonStyle: {
    borderRadius: 50,
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
    height: 52,
    width: 300,
    alignSelf: "center",
  },

  backButtonStyle: {
    borderRadius: 50,
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
    height: 52,
    width: 350,
    alignSelf: "center",
  },
  submitBackButtonStyle: {
    borderRadius: 50,
    justifyContent: "center",
    height: 52,
    width: 200,
    borderColor: Colors.WHITE,
    borderWidth: 1,
  },
  bodyContainer: {
    alignItems: "center",
  },
  buttonsContainer: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  backButtonContainer: {
    marginTop: 80,
    flex: 1,
  },
  submitLoginButtonContainer: {
    flex: 1,
  },
  emptyContainer: {
    flex: 1,
  },
});
